import { Injectable } from "@angular/core";
import { AppState } from "@app/app.module";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from "rxjs/operators";
import { AppConstant } from "../constants/app-constant";
import { IDateService } from "./interfaces/i-date-service.inteface";

@Injectable({ providedIn: 'root' })
export class DateService implements IDateService {
  private defaultFormat = AppConstant.DefaultDateFormat;
  private onFormatChanged: BehaviorSubject<string> = new BehaviorSubject<string>(AppConstant.DefaultDateFormat);
  constructor(private store: Store<AppState>,) {
    this.store.select(x => x.tenantSetting).subscribe(x => {
      if (x) {
        const result = (x.dateFormat !== null && x.dateFormat !== undefined) ? x.dateFormat : this.defaultFormat;
        this.onFormatChanged.next(result);
      }

    });
  }

  getDateFormat(isUpperCase: boolean = true) {
    return this.onFormatChanged.pipe(map(x => {
      if (x) {
        return isUpperCase ? x.toUpperCase() : x;
      } else {
        return isUpperCase ? this.defaultFormat.toUpperCase() : this.defaultFormat;
      }
    }));
  }
}
